import AdidasWhiteLogo from "../assets/svg/adidas_white.svg"
import AdidasBlackLogo from "../assets/svg/adidas_black.svg"

let returnsAdidas = {}

returnsAdidas.orderType = 31
returnsAdidas.accountType = 100

returnsAdidas.renderLogoW = () => {
  return (
    <img
      className="logo-service-icon returns-adidas"
      src={AdidasWhiteLogo}
      alt={"logo adidas"}
    />
  )
}
returnsAdidas.renderLogo = () => {
  return (
    <img
      className="logo-service-icon returns-adidas"
      src={AdidasBlackLogo}
      alt={"logo adidas"}
    />
  )
}

returnsAdidas.formatWaybill = (value) => {
  return value
}

returnsAdidas.barcodeMinLength = 5

returnsAdidas.validatePackageBarcode = (barcode) => {
  if (!barcode) {
    return false
  }
  if (barcode.length != 13) {
    console.log(
      "Adidas -> validate:" + barcode + "Not correct length=" + barcode.length
    )
    return false
  }
  //const barcodeRegex = /^[a-zA-Z0-9]+$/
  ///const barcodeRegex =  /[^0-9a-zA-Z]{5,50}$/
  const barcodeRegex = /[rR]{2}[0-9a-zA-Z]{11}$/
  const res = barcodeRegex.test(barcode)
  console.log("Adidas -> validate:" + barcode + " is " + res)
  return res
}

export const returnsAdidasProvider = returnsAdidas
